import React, { useEffect, useRef, useState, forwardRef, LegacyRef } from "react";
import SlInput from "@shoelace-style/shoelace/dist/react/input";

interface Props {
  placeholder?: string;
  onChange: (data: string) => void;
  onBlur?: () => void;
  className?: string | undefined;
  type?:
    | "date"
    | "datetime-local"
    | "email"
    | "number"
    | "password"
    | "search"
    | "tel"
    | "text"
    | "time"
    | "url";
  size?: "small" | "medium" | "large" | undefined;
  defaultValue?: string;
  disabled?: boolean;
  value?: string;
  required?: boolean;
  onlyNumbers?: boolean;
  minLength?: number;
  maxLength?: number;
}

const Input = forwardRef<typeof SlInput, Props>((props, ref) => {
  const {
    onChange,
    onBlur,
    placeholder = "",
    className = "",
    type,
    size = "medium",
    defaultValue,
    disabled,
    value: valueProps,
    required = false,
    onlyNumbers = false,
    minLength,
    maxLength,
  } = props;
  
  const [value, setValue] = useState(defaultValue || valueProps || "");
  const [touched, setTouched] = useState(false);

  useEffect(() => {
    if (defaultValue) {
      setValue(defaultValue);
    }
  }, [defaultValue]);

  useEffect(() => {
    if (valueProps !== undefined) {
      setValue(valueProps);
      setTouched(false);
    }
  }, [valueProps]);

  const handleChange = (text: string) => {
    let processedText = text;
    
    // Validar solo números si está habilitado
    if (onlyNumbers) {
      // Permitir solo números enteros (sin decimales)
      processedText = text.replace(/[^0-9]/g, '');
    }
    
    // Validar longitud mínima y máxima
    if (minLength !== undefined && processedText.length < minLength) {
      return; // No actualizar si no cumple la longitud mínima
    }
    
    if (maxLength !== undefined && processedText.length > maxLength) {
      processedText = processedText.substring(0, maxLength);
    }
    
    onChange(processedText);
    setValue(processedText);
    setTouched(true);
  };

  const handleBlur = () => {
    setTouched(true);
    if (onBlur) {
      onBlur();
    }
  };

  const isInvalid = required && touched && !value;

  return (
    <SlInput
      className={className}
      placeholder={placeholder}
      defaultValue={defaultValue}
      disabled={disabled}
      value={value}
      type={type} 
      ref={ref as LegacyRef<React.ElementRef<typeof SlInput>>}
      onSlInput={(e: any) => handleChange(e?.target?.value)}
      onBlur={handleBlur}
      size={size}
      required={required}
      onInvalid={() => {
        console.log("onInvalid");
      }}
    />
  );
});

Input.displayName = 'Input';

export default Input;
